const styles = theme => ({
  paper: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  dropZone: {
    border: `2px dashed ${theme.palette.grey[400]}`,
    borderRadius: 8,
    padding: theme.spacing(8, 4),
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 200ms ease',
    backgroundColor: theme.palette.grey[50],
    '&:hover': {
      borderColor: theme.palette.primary[400],
      backgroundColor: theme.palette.grey[100],
    },
  },
  dropZoneActive: {
    borderColor: theme.palette.primary[500],
    backgroundColor: theme.palette.primary[50],
  },
  dropZoneIcon: {
    fontSize: 64,
    color: theme.palette.grey[500],
    marginBottom: theme.spacing(1),
  },
  hiddenInput: {
    display: 'none',
  },
  editor: {
    display: 'flex',
    gap: theme.spacing(3),
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  cropperPane: {
    flex: '1 1 600px',
    minWidth: 0,
  },
  sidePane: {
    flex: '0 0 280px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  cropImg: {
    maxWidth: '100%',
    maxHeight: '70vh',
    display: 'block',
  },
  previewBox: {
    width: 256,
    height: 144,
    backgroundColor: '#000',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflow: 'hidden',
  },
  previewImg: {
    width: '100%',
    height: '100%',
    display: 'block',
  },
  info: {
    fontSize: 13,
    color: theme.palette.grey[700],
    lineHeight: 1.6,
  },
  infoLabel: {
    fontWeight: 500,
    color: theme.palette.grey[900],
  },
  actionsRow: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    flexWrap: 'wrap',
  },
  validatedRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  validatedPreview: {
    maxWidth: '100%',
    width: 960,
    aspectRatio: '16 / 9',
    backgroundColor: '#000',
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  validatedPreviewImg: {
    width: '100%',
    height: '100%',
    display: 'block',
  },
  validatedActions: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  warning: {
    color: theme.palette.warning ? theme.palette.warning.main : '#ff9800',
    fontSize: 13,
    marginTop: theme.spacing(1),
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(8),
    gap: theme.spacing(2),
  },
});

export default styles;
